/*eslint no-console: 0*/
import RaceMixins from '../../../../components/_mixins/races'
import VerbiageMixin from '../../verbiage'

import Timeslot from './timeslot'
import TimeslotGroup from './timeslot-group'
import {coerceBoolean} from '../../../../lib/utils'

const components = {
  Timeslot,
  TimeslotGroup
}

export default {
  name: 'timeslot-selector-box',

  mixins: [RaceMixins, VerbiageMixin],
  components,
  props: {
    raceSettingProduct: {}
  },
  data() {
    return {

    }
  },
  computed: {
    hasSelectedSlot() {
      return !_.isEmpty(this.selectedSlots)
    },
    allSlots() {
      return this.filteredSlotsByRaceType
    },
    numRetrievedSlots() {
      return _.values(this.allSlots).length
    },
    noRetrievedSlots() {
      return _.isEmpty(this.allSlots)
    },

    filteredSlotsByRaceTogether() {
      const requiredKarts = this.totalPlayers || 1
      return _.pickBy(this.allSlots, ({karts = 0}) => karts >= requiredKarts)
    },
    numRaceTogetherSlots() {
      return _.values(this.filteredSlotsByRaceTogether).length
    },
    hasRaceTogetherSlots() {
      const slots = this.filteredSlotsByRaceTogether

      const numAvailableSlots = this.numRaceTogetherSlots
      const minRequiredSlots = this.minSelectableTimeslots

      const requiredRaces = this.numberOfAdultRaces
      const availableRaces = _.reduce(slots, (s, {karts = 0}) => s + karts, 0)
      return numAvailableSlots >= minRequiredSlots && availableRaces >= requiredRaces
    },
    finalRaceTogetherSlots() {
      return this.hasRaceTogetherSlots ? this.filteredSlotsByRaceTogether : {}
    },

    filteredSlotsByRaceSeparately() {
      return this.allSlots
    },
    numRaceSeparatelySlots() {
      return _.values(this.filteredSlotsByRaceSeparately).length
    },
    hasRaceSeparatelySlots() {
      const slots = this.filteredSlotsByRaceSeparately

      const numAvailableSlots = this.numRaceSeparatelySlots
      const minRequiredSlots = this.minSelectableTimeslots

      const requiredRaces = this.numberOfAdultRaces
      const availableRaces = _.reduce(slots, (s, {karts = 0}) => s + karts, 0)
      return numAvailableSlots >= minRequiredSlots && availableRaces >= requiredRaces
    },
    finalRaceSeparatelySlots() {
      return this.hasRaceSeparatelySlots ? this.filteredSlotsByRaceSeparately : {}
    },

    // race together option is not available but race separately option is available
    isBusyDay() {
      return !this.hasRaceTogetherSlots && this.hasRaceSeparatelySlots
    },
    canRaceSeparately() {
      return true
    },
    isBusyDayOrRacingSeparately() {
      return this.isBusyDay || this.isRacingSeparately
    },

    selectableSlots() {
      return this.isRacingSeparately ? this.finalRaceSeparatelySlots : this.finalRaceTogetherSlots
    },
    numSelectableSlots() {
      return _.values(this.selectableSlots).length
    },
    noSelectableSlots() {
      return _.isEmpty(this.selectableSlots)
    },
    autoRaceSeparately() {
      return coerceBoolean(this.raceSettingProduct.auto_race_separately)
    },
  },
  watch: {
    // race together option is not available but race separately option is available
    isBusyDay(value) {
      if (value) {
        if (this.canRaceSeparately && this.autoRaceSeparately) {
          this.raceSeparately = 'yes'
        }
      } else {
        this.raceSeparately = 'no'
      }
    },
    raceSeparately(value) {
      this.clearLocalCart()
      this.cleanTimeslots()
    }
  },
  created() {

  },
  methods: {

  },

}
